/** Возвращает параметры подключения к API */
export const getApiConfig = () => {
    const baseURL = import.meta.env.VITE_API_BASE_URL;
    const environment = import.meta.env.VITE_APP_ENV || 'development';

    if (!baseURL) {
        throw new Error('VITE_API_BASE_URL is required');
    }

    console.log(`API Configuration: ${environment} -> ${baseURL}`);

    return {
        baseURL,
        environment,
        isDevelopment: environment === 'development',
        isStaging: environment === 'staging',
        isProduction: environment === 'production',
        timeout: 20000,
    };
};

export const API_CONFIG = getApiConfig();
